import { Drawer } from '@mui/material'
import { NAV_RAIL_BG } from 'utils/brand-colors'
import Sidebar from '../sidebar/sidebar.component'

type MobileNavProps = {
  open: boolean
  close: () => void
}

const MobileNav = ({ open, close }: MobileNavProps) => {
  return (
    <Drawer
      open={open}
      onClose={close}
      PaperProps={{
        sx: {
          width: 288,
          bgcolor: NAV_RAIL_BG,
          border: 'none',
        },
      }}
    >
      <Sidebar close={close} inDrawer fullViewportHeight />
    </Drawer>
  )
}

export default MobileNav
